export var Kind;
(function (Kind) {
    Kind["Cook"] = "Cook";
    Kind["Coupon"] = "Coupon";
    Kind["Customer"] = "Customer";
    Kind["Order"] = "Order";
    Kind["Pet"] = "Pet";
    Kind["PendingOrder"] = "PendingOrder";
    Kind["ProductType"] = "ProductType";
    Kind["Recipe"] = "Recipe";
    Kind["ReferralInvite"] = "ReferralInvite";
    Kind["Shipment"] = "Shipment";
    Kind["VetContact"] = "VetContact";
    Kind["None"] = "";
})(Kind || (Kind = {}));
